import { render, staticRenderFns } from "./ChangeAvatarModal.vue?vue&type=template&id=35bcaa07&scoped=true&"
import script from "./ChangeAvatarModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAvatarModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAvatarModal.vue?vue&type=style&index=0&id=35bcaa07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bcaa07",
  null
  
)

export default component.exports